<template>
   <v-container>
        <div class="text-left" style="margin-bottom:20px;">
            <router-link to="/uk">
                <v-btn
                    color="secondary"
                    class="text-right"
                    style="width:250px"
                >
                    Back
                </v-btn>
            </router-link>
        </div>           
      <v-row>
        <v-col cols="12" class="text-left">
          <h1>February 14</h1>
          <div class="text-left">
            <p>Tower of London and Tower Bridge</p>
            <a href="/uk/14TowerOfLondon.jpeg"><img alt="Tower of London" class="uitk-image-media" src="14TowerOfLondon.jpeg" style="width: 17%; height: auto;"></a>    
            <a href="/uk/14TowerBridge.jpeg"><img alt="Tower Bridge" class="uitk-image-media" src="14TowerBridge.jpeg" style="width: 17%; height: auto;"></a>    
            <p>London Museum</p>
            <a href="/uk/14Museum7.jpeg"><img alt="London Museum" class="uitk-image-media" src="14Museum7.jpeg" style="width: 17%; height: auto;"></a>    
            <a href="/uk/14Museum.jpeg"><img alt="London Museum" class="uitk-image-media" src="14Museum.jpeg" style="width: 17%; height: auto;"></a>    
            <a href="/uk/14Museum2.jpeg"><img alt="London Museum" class="uitk-image-media" src="14Museum2.jpeg" style="width: 17%; height: auto;"></a>    
            <a href="/uk/14Museum4.jpeg"><img alt="London Museum" class="uitk-image-media" src="14Museum4.jpeg" style="width: 17%; height: auto;"></a>    
          </div>      
          <div class="text-left">
              <a href="/uk/14Museum6.jpeg"><img alt="London Museum" class="uitk-image-media" src="14Museum6.jpeg" style="width: 17%; height: auto;"></a>    
            <a href="/uk/14Museum3.jpeg"><img alt="London Museum" class="uitk-image-media" src="14Museum3.jpeg" style="width: 17%; height: auto;"></a>    
            <p>Russell Square</p>
            <a href="/uk/14Museum5.jpeg"><img alt="Russell Square" class="uitk-image-media" src="14Museum5.jpeg" style="width: 17%; height: auto;"></a>    
          </div>      
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  
  //vue 3 style
  import { ref } from 'vue'
  
  export default {
    name: 'HomeView',
    setup() {
      ////
    }
  }
  </script>